import React, { forwardRef, useEffect, useState } from 'react';

import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFiltersTranslation } from '../../i18n';
import { useEventListFilters } from '../../useEventListFilters';

const validateFaceIds = validate.multipleUuid();

const getIds = (value: string): string[] | undefined => {
  const ids = value
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);

  if (ids.length === 0) return undefined;
  return ids;
};

function FaceIdFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useEventListFiltersTranslation();
  const [faceIds, setFaceIds] = useState('');
  const [error, setError] = useState('');
  const { filters, updateFilters, updateFiltersDebounced } = useEventListFilters();

  const handleChange = (value: string) => {
    setFaceIds(value);

    const validationResult = validateFaceIds(value);
    if (typeof validationResult === 'string') {
      setError(validationResult);
      return;
    }

    setError('');
    updateFiltersDebounced({ face_ids: getIds(value) });
  };

  const reset = () => {
    setFaceIds('');
    setError('');
    updateFilters({ face_ids: undefined });
  };

  useEffect(() => {
    setFaceIds(filters.face_ids?.join(',') ?? '');
  }, [filters.face_ids]);

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={filters.face_ids === undefined}
      onClickReset={reset}
      ref={ref}
      title={<div className="Subtitle-2">{t('face_ids')}</div>}
    >
      <Control.Input
        errorMessage={error}
        hasError={!!error}
        id="face_ids"
        isClearable
        name="face_ids"
        onChangeValue={handleChange}
        onClear={reset}
        value={faceIds}
      />
    </PopoverWithButton>
  );
}

const FaceIdFilterPopoverWithRef = forwardRef(FaceIdFilterPopover);
export { FaceIdFilterPopoverWithRef as FaceIdFilterPopover };
